import { render, staticRenderFns } from "./productDetails.vue?vue&type=template&id=b33f4d76&scoped=true"
import script from "./productDetails.vue?vue&type=script&lang=js"
export * from "./productDetails.vue?vue&type=script&lang=js"
import style0 from "./productDetails.vue?vue&type=style&index=0&id=b33f4d76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33f4d76",
  null
  
)

export default component.exports